import { render, staticRenderFns } from "./unFormal.vue?vue&type=template&id=28be0006&"
import script from "./unFormal.vue?vue&type=script&lang=js&"
export * from "./unFormal.vue?vue&type=script&lang=js&"
import style0 from "./unFormal.vue?vue&type=style&index=0&id=28be0006&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports